export default __webpack_public_path__ + "static/media/small-cloud.8b488cb9.svg";